import { BadgeV3 } from '@cimplico/components';
import { CalendarDaysIcon, PaperAirplaneIcon } from '@heroicons/react/20/solid';
import { Link } from 'react-router-dom';
import Currency from '../../../components/currency/Currency';
import JournalStatusBadge from '../../../components/journal-status-badge/JournalStatusBadge';
import { useFirmContext } from '../../../providers/FirmProvider';
import { JournalOverview } from '../../../types/journal';
import { Worksheet } from '../../../types/worksheet';
import { formatDateNumeric } from '../../../utilities/formatting';

type JournalPreviewProps = {
    journal: JournalOverview;
    worksheet: Worksheet;
};

function JournalPreview({ journal, worksheet }: JournalPreviewProps): JSX.Element {
    return (
        <div className="grid grid-cols-[subgrid] col-span-full px-4 py-2 gap-8 border-t border-gray-200">
            <div className="col-span-3">
                <Link to={`./${worksheet.id}?tab=journals`} className="text-indigo-600 text-xs font-medium line-clamp-1">
                    JNL#{journal.reference.toString().padStart(3, '0')} - {journal.narration}
                </Link>
                <p className="text-xs text-gray-600 flex items-center mt-1">
                    <CalendarDaysIcon className="text-gray-500 h-4 w-4 mr-1" />
                    <label>{journal.date ? formatDateNumeric(journal.date) : '-'}</label>
                </p>
            </div>
            <div className="text-xs text-gray-600 font-medium text-right col-span-2">
                <Currency value={journal.debitTotal} description="Dr" />
                <Currency value={journal.creditTotal} description="Cr" withParentheses />
            </div>

            <div className="flex items-center justify-center">
                <JournalStatusBadge status={journal.status} iconOnly />
            </div>
        </div>
    );
}

export default JournalPreview;
